export default {
  modalTitle: {
    id: 'product_page_verified_refurbished_new_modal_main_title',
    defaultMessage: 'Verified Refurbished',
  },
} as const
